<template>
  <v-app >
    <NavBar v-if="isAuthorized"/>
    <div class="main-container" v-if="isAuthorized">
      <v-main>
        <router-view/>
      </v-main>
    </div>

    <v-main v-else>
      <router-view/>
    </v-main>
    
    <Footer v-if="isAuthorized"/>
  </v-app>
</template>

<style src="./assets/styles/App.css">
</style>

<script>
import HelloWorld from './components/HelloWorld';
import NavBar from './components/Navigation/NavigationBar/NavigationBar';
import Footer from './components/Navigation/Footer/FooterBar';
import API_KEY from './assets/GMapsApiKey.json'

import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
 Vue.use(VueGoogleMaps, {
  load: {
    key: API_KEY.text,
    libraries: "places" // necessary for places input
  }
})

export default {
  name: 'App',
  components: {
    HelloWorld,
    NavBar,
    Footer
  },
  computed:{
    isAuthorized(){
      if(this.$store.state.habilitado){
        //console.log("isAuthorized")
        this.timer = setTimeout(this.reviewInterval, 15000);
      }
      else{
        //console.log("Authorization is needed")
        this.dialog = false
      }

      var end = this.$moment.unix(this.$store.state.expire)
      var actual = Vue.prototype.$moment.utc();
      var duration = Vue.prototype.$moment.duration(end.diff(actual));

      return this.$store.state.habilitado && duration._milliseconds > 0
    }
  },
  data: () => ({
    //
  }),
};
</script>

